import { Injectable } from '@angular/core';
import { SavedCartFacade } from '@spartacus/cart/saved-cart/root';

@Injectable({
  providedIn: 'root',
})
export abstract class GenSavedCartFacade extends SavedCartFacade {

  abstract override loadSavedCart(cartId: string, cartOwner?: string): void;

  abstract override restoreSavedCart(
    cartId: string,
    cartOwner?: string,
    hideMessages?: boolean
  ): void;

  abstract override deleteSavedCart(cartId: string, cartOwner?: string): void;

  abstract override cloneSavedCart(
    cartId: string,
    saveCartName?: string,
    cartOwner?: string
  ): void;
}
